const stripTags = function(value) {
  if (typeof value !== 'string') {
    return value;
  }

  return value.replace(/<[^>]*>?/gm, '');
};

const stripTrailingSlash = function(value) {
  if (!value.endsWith('/')) {
    return value;
  }

  return value.slice(0, -1);
};

export {
  stripTags,
  stripTrailingSlash,
};
